import { render, staticRenderFns } from "./VueSaxTypeAheadTemplate.vue?vue&type=template&id=ca8fdf1e&scoped=true"
import script from "./VueSaxTypeAheadTemplate.vue?vue&type=script&lang=js"
export * from "./VueSaxTypeAheadTemplate.vue?vue&type=script&lang=js"
import style0 from "./VueSaxTypeAheadTemplate.vue?vue&type=style&index=0&id=ca8fdf1e&prod&scoped=true&lang=css"
import style1 from "./VueSaxTypeAheadTemplate.vue?vue&type=style&index=1&id=ca8fdf1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8fdf1e",
  null
  
)

export default component.exports